import * as React from 'react';
import * as Fuse from 'fuse.js';
import { find } from 'lodash';
import { Card, Form, Notification, Tooltip } from '../';
import permissions from '../../data/permissions';
import fields from '../../data/fields';
import search from '../../data/search';

interface Props {
  permissions: Array<any>;
  handleDelete: any;
}

interface State {
  items: Array<any>;
}

class PermissionList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.permissions,
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch(data) {
    const items = this.props.permissions;
    items.forEach((item, index) => {
      const definition: any = find(permissions, { name: item.permission });
      if (definition) {
        items[index].description = definition.description;
      }
    });
    if (data.search) {
      const fuse = new Fuse(items, search.permissions);
      this.setState({ items: fuse.search(data.search) });
    } else {
      this.setState({ items });
    }
  }

  render() {
    return (
      <div>
        <Card list>
          <Form
            type="search"
            handleChange={this.handleSearch}
            hasButton={false}
            fields={fields.permissions.search}
          />
        </Card>
        {this.props.permissions.length === 0 && (
          <Card list>
            <Notification type="default">No permissions assigned</Notification>
          </Card>
        )}
        {this.state.items.map((item) => {
          const definition: any = find(permissions, { name: item.permission });
          return (
            <Card list key={item.permission}>
              {this.props.handleDelete && (
                <span className="is-pulled-right">
                  <Tooltip text="Remove this permission">
                    <div
                      className="delete "
                      onClick={() => {
                        this.props.handleDelete(item.permission);
                      }}
                    />
                  </Tooltip>
                </span>
              )}
              <strong>{definition ? definition.title : item.permission}</strong>
              <br />
              {definition ? (
                definition.description
              ) : (
                <em>No description found</em>
              )}
            </Card>
          );
        })}
        {this.props.permissions.length > 0 &&
          this.state.items.length === 0 && (
            <Card list>
              <Notification type="default">
                No relevant permissions assigned
              </Notification>
            </Card>
          )}
      </div>
    );
  }
}

export default PermissionList;
